import React from 'react'
import './Services.css'

const services = [
  {
    id: 1,
    title: 'Software Development',
    description: 'From websites, mobile apps and web apps to full-scale platforms, we build reliable, scalable software tailored to your business needs.',
    icon: '',
    size: 'tall',
  },
  {
    id: 2,
    title: 'UI/UX Design',
    description: 'We craft intuitive, beautiful interfaces that keep users engaged and convert visitors into customers.',
    icon: '',
    size: 'wide',
  },
  {
    id: 3,
    title: 'Social Media Management',
    description: 'Consistent content, community building, and data-driven strategy across all your social platforms.',
    icon: '',
    size: 'normal',
  },
  {
    id: 4,
    title: 'SEO',
    description: 'Rank higher, get found faster. We optimize your digital presence to drive organic traffic that converts.',
    icon: '',
    size: 'normal',
  },
  {
    id: 5,
    title: 'Mentorship & Training',
    description: 'Hands-on guidance for individuals and teams looking to level up their technical and product skills.',
    icon: '',
    size: 'wide-bottom',
  },
  {
    id: 6,
    title: 'Ready-Made Solutions',
    description: 'Launch faster with our suite of pre-built SaaS products; plug in, customize, and go live.',
    icon: '',
    size: 'normal',
  },
]

function Services() {
  return (
    <section className='services' id='services'>
      <div className='services-header'>
        <h2 className='services-title'>
          Built to Scale.<br /> Designed to <span>Deliver.</span>
        </h2>
        <p className='services-subtitle'>
          From strategy to execution, our services are built around your growth;
          whether you're a startup finding your feet or a business ready to expand.
        </p>
      </div>

      <div className='services-grid'>
        {services.map((service) => (
          <div key={service.id} className={`service-card service-card--${service.size}`}>
            <div className='service-icon'>{service.icon}</div>
            <div className='service-body'>
              <h3 className='service-name'>{service.title}</h3>
              <p className='service-desc'>{service.description}</p>
            </div>
            <div className='service-card-bg-number'>{`0${service.id}`}</div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Services